import React, { useLayoutEffect, useRef } from "react";

interface PrintLabelTextProps {
  children: string;
  maxFontSize?: number;
  minFontSize?: number;
  className?: string;
  open?: boolean;
}

function PrintLabelText({ children, maxFontSize = 52, minFontSize = 10, className, open }: PrintLabelTextProps) {
  const spanRef = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    const el = spanRef.current;
    if (!el) return;

    const maxWidth = Math.floor(98 * 3.7795);

    el.style.width = "max-content";

    let fontSize = maxFontSize;
    el.style.fontSize = `${fontSize}px`;

    while (el.offsetWidth > maxWidth && fontSize > minFontSize) {
      fontSize -= 1;
      el.style.fontSize = `${fontSize}px`;
    }

    el.style.width = "";
  }, [children, maxFontSize, minFontSize, open]);

  return (
    <span
      ref={spanRef}
      className={className}
      style={{
        fontSize: `${maxFontSize}px`,
        fontWeight: 700,
        whiteSpace: "nowrap",
        letterSpacing: "-1.6px",
        lineHeight: 1,
        display: "block",
        overflow: "hidden",
      }}
    >
      {children}
    </span>
  );
}

export default React.memo(PrintLabelText);
